'use client';

import { Box, CircularProgress, Typography } from '@mui/material';

interface LoadingSpinnerProps {
  message?: string;
  size?: number;
}

/**
 * Loading Spinner component
 */
export default function LoadingSpinner({
  message = 'Đang tải...',
  size = 60,
}: LoadingSpinnerProps) {
  return (
    <Box
      sx={{
        display: 'flex',
        flexDirection: 'column',
        alignItems: 'center',
        justifyContent: 'center',
        gap: 2,
        minHeight: '200px',
      }}
    >
      <CircularProgress size={size} />
      <Typography variant='body1' color='text.secondary'>
        {message}
      </Typography>
    </Box>
  );
}
